import React 		from 'react';
import ReactDOM from 'react-dom';

import Logo from '../common/_Logo.jsx';
import BLComponent from '../core/_BLComponent.jsx';

import GettingStarted from './_GettingStarted.jsx';
import GeneralNotes from './_GeneralNotes.jsx';
import Auth from './_Auth.jsx';
import ErrorHandling from './_ErrorHandling.jsx';

import ResourceRepOrder from './_ResourceRepOrder.jsx';
import MethodOrder from './_MethodOrder.jsx';
import GetOrders from './_GetOrders.jsx';
import GetOrder from './_GetOrder.jsx';
import GetOrderItems from './_GetOrderItems.jsx';
import GetOrderMessages from './_GetOrderMessages.jsx';
import GetOrderFeedback from './_GetOrderFeedback.jsx';
import UpdateOrder from './_UpdateOrder.jsx';
import UpdateOrderStatus from './_UpdateOrderStatus.jsx';
import UpdatePaymentStatus from './_UpdatePaymentStatus.jsx';
import SendDriveThru from './_SendDriveThru.jsx';
import OrderProblemReason from './_OrderProblemReason.jsx';

import ResourceRepInventory from './_ResourceRepInventory.jsx';
import MethodInventory from './_MethodInventory.jsx';
import GetInventories from './_GetInventories.jsx'; 
import GetInventory from './_GetInventory.jsx'; 
import CreateInventory from './_CreateInventory.jsx'; 
import CreateInventories from './_CreateInventories.jsx'; 
import UpdateInventory from './_UpdateInventory.jsx'; 
import DeleteInventory from './_DeleteInventory.jsx'; 

import ResourceRepCatalog from './_ResourceRepCatalog.jsx';
import MethodCatalog from './_MethodCatalog.jsx';
import GetItem from './_GetItem.jsx';
import GetItemImage from './_GetItemImage.jsx';
import GetSupersets from './_GetSupersets.jsx';
import GetSubsets from './_GetSubsets.jsx';
import GetPriceGuide from './_GetPriceGuide.jsx';
import GetKnownColors from './_GetKnownColors.jsx';

import ResourceRepFeedback from './_ResourceRepFeedback.jsx';
import MethodFeedback from './_MethodFeedback.jsx';
import GetFeedbackList from './_GetFeedbackList.jsx';
import GetFeedback from './_GetFeedback.jsx';
import PostFeedback from './_PostFeedback.jsx';
import ReplyFeedback from './_ReplyFeedback.jsx';

import ResourceRepColor from './_ResourceRepColor.jsx';
import MethodColor from './_MethodColor.jsx';
import GetColorList from './_GetColorList.jsx';
import GetColor from './_GetColor.jsx';

import ResourceRepCategory from './_ResourceRepCategory.jsx';
import MethodCategory from './_MethodCategory.jsx';
import GetCategoryList from './_GetCategoryList.jsx';
import GetCategory from './_GetCategory.jsx';

import ResourceRepPush from './_ResourceRepPush.jsx';
import MethodPush from './_MethodPush.jsx';
import GetNotifications from './_GetNotifications.jsx';

import ResourceRepCoupon from './_ResourceRepCoupon.jsx';
import MethodCoupon from './_MethodCoupon.jsx';
import GetCoupons from './_GetCoupons.jsx';
import GetCoupon from './_GetCoupon.jsx';
import CreateCoupon from './_CreateCoupon.jsx';
import UpdateCoupon from './_UpdateCoupon.jsx';
import DeleteCoupon from './_DeleteCoupon.jsx';

import ResourceRepSetting from './_ResourceRepSetting.jsx';
import MethodSetting from './_MethodSetting.jsx';
import GetShippingMethods from './_GetShippingMethods.jsx';
import GetShippingMethod from './_GetShippingMethod.jsx';

import ResourceRepMember from './_ResourceRepMember.jsx';
import MethodMember from './_MethodMember.jsx';
import GetMemberRating from './_GetMemberRating.jsx';
import GetMemberNote from './_GetMemberNote.jsx';
import CreateMemberNote from './_CreateMemberNote.jsx';
import UpdateMemberNote from './_UpdateMemberNote.jsx';
import DeleteMemberNote from './_DeleteMemberNote.jsx';

import ResourceRepItemMapping from './_ResourceRepItemMapping.jsx';
import MethodItemMapping from './_MethodItemMapping.jsx';
import GetElementID from './_GetElementID.jsx';
import GetItemNumber from './_GetItemNumber.jsx';


import Changelog from './_Changelog.jsx';
import FeedbackRequest from './_FeedbackRequest.jsx';

export default class Api extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			altPage: '',
			pages: [
					{id: '0', active: true, slug: 'started', name: 'Getting Started'}

				,	{id: '1', active: false, slug: 'references', name: 'API References'}
				,	{id: '1.1', active: false, slug: 'general-notes', name: 'General Notes', category: 'references', meta: {group: 'Overview', desc: '', parent: ''}}
				,	{id: '1.2', active: false, slug: 'auth', name: 'Authentication & Authorization', category: 'references', meta: {group: 'Overview', desc: '', parent: ''}}
				,	{id: '1.3', active: false, slug: 'error-handling', name: 'Error Handling', category: 'references', meta: {group: 'Overview', desc: '', parent: ''}}
				,	{id: '1.4', active: false, slug: 'resource-representations-order', name: 'Resource Representation', category: 'references', meta: {group: 'Order', desc: '', parent: ''}}
				,	{id: '1.5', active: false, slug: 'method-order', name: 'Method', category: 'references', meta: {group: 'Order', desc: '', parent: ''}}
				,	{id: '1.5.1', active: false, slug: 'get-orders', name: 'Get orders', category: 'references', meta: {group: 'Order', desc: 'Lists the orders you received or placed', parent: '1.5'}}
				,	{id: '1.5.2', active: false, slug: 'get-order', name: 'Get order', category: 'references', meta: {group: 'Order', desc: 'Gets details of a specific order', parent: '1.5'}}
				,	{id: '1.5.3', active: false, slug: 'get-order-items', name: 'Get order items', category: 'references', meta: {group: 'Order', desc: 'Retrieves a list of items for the specified order', parent: '1.5'}}
				,	{id: '1.5.4', active: false, slug: 'get-order-messages', name: 'Get order messages', category: 'references', meta: {group: 'Order', desc: 'Retrieves a list of messages for the specified order', parent: '1.5'}}
				,	{id: '1.5.5', active: false, slug: 'get-order-feedback', name: 'Get order feedback', category: 'references', meta: {group: 'Order', desc: 'Retrieves a list of feedback for the specified order', parent: '1.5'}}
				,	{id: '1.5.6', active: false, slug: 'update-order', name: 'Update order', category: 'references', meta: {group: 'Order', desc: 'Updates properties of a specific order', parent: '1.5'}}
				,	{id: '1.5.7', active: false, slug: 'update-order-status', name: 'Update order status', category: 'references', meta: {group: 'Order', desc: 'Updates the status of a specific order', parent: '1.5'}}
				,	{id: '1.5.8', active: false, slug: 'update-payment-status', name: 'Update payment status', category: 'references', meta: {group: 'Order', desc: 'Updates the payment status of a specific order', parent: '1.5'}}
				,	{id: '1.5.9', active: false, slug: 'send-drive-thru', name: 'Send drive thru', category: 'references', meta: {group: 'Order', desc: 'Send "Thank You, Drive Thru!" e-mail to a buyer', parent: '1.5'}}
				,	{id: '1.5.10', active: false, slug: 'file-npb-alert', name: 'File NPB Alert', category: 'references', meta: {group: 'Order', desc: 'Files a Non-Paying Buyer alert.', parent: '1.5'}, incomplete: true}
				,	{id: '1.5.11', active: false, slug: 'remove-npb-alert', name: 'Remove NPB Alert', category: 'references', meta: {group: 'Order', desc: 'Removes a Non-Paying Buyer alert', parent: '1.5'}, incomplete: true}
				
				,	{id: '1.6', active: false, slug: 'resource-representations-inventory', name: 'Resource Representation', category: 'references', meta: {group: 'Store Inventory', desc: '', parent: ''}}
				,	{id: '1.7', active: false, slug: 'method-inventory', name: 'Method', category: 'references', meta: {group: 'Store Inventory', desc: '', parent: ''}}
				,	{id: '1.7.1', active: false, slug: 'get-inventories', name: 'Get store inventories', category: 'references', meta: {group: 'Store Inventory', desc: 'Lists your store inventories', parent: '1.7'}}
				,	{id: '1.7.2', active: false, slug: 'get-inventory', name: 'Get store inventory', category: 'references', meta: {group: 'Store Inventory', desc: 'Gets the information about a specific store inventory', parent: '1.7'}}
				,	{id: '1.7.3', active: false, slug: 'create-inventory', name: 'Create store inventory', category: 'references', meta: {group: 'Store Inventory', desc: 'Creates a new store inventory with an item', parent: '1.7'}}
				,	{id: '1.7.4', active: false, slug: 'create-inventories', name: 'Create store inventories', category: 'references', meta: {group: 'Store Inventory', desc: 'Creates multiple store inventories in a single request', parent: '1.7'}}
				,	{id: '1.7.5', active: false, slug: 'update-inventory', name: 'Update store inventory', category: 'references', meta: {group: 'Store Inventory', desc: 'Updates the specified store inventory', parent: '1.7'}}
				,	{id: '1.7.6', active: false, slug: 'delete-inventory', name: 'Delete store inventory', category: 'references', meta: {group: 'Store Inventory', desc: 'Deletes the specified store inventory', parent: '1.7'}}
				


				,	{id: '1.8', active: false, slug: 'resource-representations-catalog', name: 'Resource Representation', category: 'references', meta: {group: 'Catalog Item', desc: '', parent: ''}}
				,	{id: '1.9', active: false, slug: 'method-catalog', name: 'Method', category: 'references', meta: {group: 'Catalog Item', desc: '', parent: ''}}
				,	{id: '1.9.1', active: false, slug: 'get-item', name: 'Get item', category: 'references', meta: {group: 'Catalog Item', desc: 'Gets information of the specified item in BrickLink catalog', parent: '1.9'}}
				,	{id: '1.9.2', active: false, slug: 'get-item-image', name: 'Get item image', category: 'references', meta: {group: 'Catalog Item', desc: 'Gets image URL of the specified item by colors', parent: '1.9'}}
				,	{id: '1.9.3', active: false, slug: 'get-supersets', name: 'Get supersets', category: 'references', meta: {group: 'Catalog Item', desc: 'Gets a list of items that include the specified item', parent: '1.9'}}
				,	{id: '1.9.4', active: false, slug: 'get-subsets', name: 'Get subsets', category: 'references', meta: {group: 'Catalog Item', desc: 'Gets a list of items that are included in the specified item', parent: '1.9'}}
				,	{id: '1.9.5', active: false, slug: 'get-price-guide', name: 'Get price guide', category: 'references', meta: {group: 'Catalog Item', desc: 'Gets the price statistics of the specified item in BrickLink catalog', parent: '1.9'}}
				,	{id: '1.9.6', active: false, slug: 'get-known-colors', name: 'Get known colors', category: 'references', meta: {group: 'Catalog Item', desc: 'Gets currently known colors of the item', parent: '1.9'}}

				,	{id: '1.10', active: false, slug: 'resource-representations-feedback', name: 'Resource Representation', category: 'references', meta: {group: 'Feedback', desc: '', parent: ''}}
				,	{id: '1.11', active: false, slug: 'method-feedback', name: 'Method', category: 'references', meta: {group: 'Feedback', desc: '', parent: ''}}
				,	{id: '1.11.1', active: false, slug: 'get-feedback-list', name: 'Get feedback list', category: 'references', meta: {group: 'Feedback', desc: 'Gets a list of feedback you received or posted', parent: '1.11'}}
				,	{id: '1.11.2', active: false, slug: 'get-feedback', name: 'Get feedback', category: 'references', meta: {group: 'Feedback', desc: 'Gets a specified feedback', parent: '1.11'}}
				,	{id: '1.11.3', active: false, slug: 'post-feedback', name: 'Post feedback', category: 'references', meta: {group: 'Feedback', desc: 'Posts a new feedback about the transaction', parent: '1.11'}}
				,	{id: '1.11.4', active: false, slug: 'reply-feedback', name: 'Reply feedback', category: 'references', meta: {group: 'Feedback', desc: 'Replies to the feedback you received', parent: '1.11'}}
				
				,	{id: '1.12', active: false, slug: 'resource-representations-color', name: 'Resource Representation', category: 'references', meta: {group: 'Color', desc: '', parent: ''}}
				,	{id: '1.13', active: false, slug: 'method-color', name: 'Method', category: 'references', meta: {group: 'Color', desc: '', parent: ''}}
				,	{id: '1.13.1', active: false, slug: 'get-color-list', name: 'Get color list', category: 'references', meta: {group: 'Color', desc: 'Lists all of the colors defined within BrickLink catalog', parent: '1.13'}}
				,	{id: '1.13.2', active: false, slug: 'get-color', name: 'Get color', category: 'references', meta: {group: 'Color', desc: 'Gets information about a specific color', parent: '1.13'}}

				,	{id: '1.14', active: false, slug: 'resource-representations-category', name: 'Resource Representation', category: 'references', meta: {group: 'Category', desc: '', parent: ''}}
				,	{id: '1.15', active: false, slug: 'method-category', name: 'Method', category: 'references', meta: {group: 'Category', desc: '', parent: ''}}
				,	{id: '1.15.1', active: false, slug: 'get-category-list', name: 'Get category list', category: 'references', meta: {group: 'Category', desc: 'Lists all of the categories defined within BrickLink catalog', parent: '1.15'}}
				,	{id: '1.15.2', active: false, slug: 'get-category', name: 'Get category', category: 'references', meta: {group: 'Category', desc: 'Gets information about a specific category', parent: '1.15'}}
				
				,	{id: '1.16', active: false, slug: 'resource-representations-push', name: 'Resource Representation', category: 'references', meta: {group: 'Push Notification', desc: '', parent: ''}}
				,	{id: '1.17', active: false, slug: 'method-push', name: 'Method', category: 'references', meta: {group: 'Push Notification', desc: '', parent: ''}}
				,	{id: '1.17.1', active: false, slug: 'get-notifications', name: 'Get notifications', category: 'references', meta: {group: 'Push Notification', desc: 'Lists all unread push notifications', parent: '1.17'}}

				,	{id: '1.18', active: false, slug: 'resource-representations-coupon', name: 'Resource Representation', category: 'references', meta: {group: 'Coupon', desc: '', parent: ''}}
				,	{id: '1.19', active: false, slug: 'method-coupon', name: 'Method', category: 'references', meta: {group: 'Coupon', desc: '', parent: ''}}
				,	{id: '1.19.1', active: false, slug: 'get-coupons', name: 'Get coupons', category: 'references', meta: {group: 'Coupon', desc: 'Lists coupons you received or created', parent: '1.19'}}
				,	{id: '1.19.2', active: false, slug: 'get-coupon', name: 'Get coupon', category: 'references', meta: {group: 'Coupon', desc: 'Gets a specific coupon', parent: '1.19'}}
				,	{id: '1.19.3', active: false, slug: 'create-coupon', name: 'Create coupon', category: 'references', meta: {group: 'Coupon', desc: 'Creates a new coupon', parent: '1.19'}}
				,	{id: '1.19.4', active: false, slug: 'update-coupon', name: 'Update coupon', category: 'references', meta: {group: 'Coupon', desc: 'Updates the specified coupon', parent: '1.19'}}
				,	{id: '1.19.5', active: false, slug: 'delete-coupon', name: 'Delete coupon', category: 'references', meta: {group: 'Coupon', desc: 'Deletes the specified coupon', parent: '1.19'}}
				
				,	{id: '1.20', active: false, slug: 'resource-representations-setting', name: 'Resource Representation', category: 'references', meta: {group: 'Setting', desc: '', parent: ''}}
				,	{id: '1.21', active: false, slug: 'method-setting', name: 'Method', category: 'references', meta: {group: 'Setting', desc: '', parent: ''}}
				,	{id: '1.21.1', active: false, slug: 'get-shipping-methods', name: 'Get shipping methods', category: 'references', meta: {group: 'Setting', desc: "Lists your store's shipping methods", parent: '1.21'}}
				,	{id: '1.21.2', active: false, slug: 'get-shipping-method', name: 'Get shipping method', category: 'references', meta: {group: 'Setting', desc: 'Gets the specified shipping method of your store', parent: '1.21'}}

				,	{id: '1.22', active: false, slug: 'resource-representations-member', name: 'Resource Representation', category: 'references', meta: {group: 'Member', desc: '', parent: ''}}
				,	{id: '1.23', active: false, slug: 'method-member', name: 'Method', category: 'references', meta: {group: 'Member', desc: '', parent: ''}}
				,	{id: '1.23.1', active: false, slug: 'get-member-rating', name: 'Get member rating', category: 'references', meta: {group: 'Member', desc: "Gets feedback ratings of a specific member", parent: '1.23'}}
				,	{id: '1.23.2', active: false, slug: 'get-member-note', name: 'Get member note', category: 'references', meta: {group: 'Member', desc: "Gets your notes on a member", parent: '1.23'}}
				,	{id: '1.23.3', active: false, slug: 'create-member-note', name: 'Create member note', category: 'references', meta: {group: 'Member', desc: "Creates note about a specific member", parent: '1.23'}}
				,	{id: '1.23.4', active: false, slug: 'update-member-note', name: 'Update member note', category: 'references', meta: {group: 'Member', desc: "Updates the specified notes", parent: '1.23'}}
				,	{id: '1.23.5', active: false, slug: 'delete-member-note', name: 'Delete member note', category: 'references', meta: {group: 'Member', desc: "Deletes the specified notes", parent: '1.23'}}

				,	{id: '1.24', active: false, slug: 'resource-representations-mapping', name: 'Resource Representation', category: 'references', meta: {group: 'Item Mapping', desc: '', parent: ''}}
				,	{id: '1.25', active: false, slug: 'method-mapping', name: 'Method', category: 'references', meta: {group: 'Item Mapping', desc: '', parent: ''}}
				,	{id: '1.25.1', active: false, slug: 'get-elementid', name: 'Get ElementID', category: 'references', meta: {group: 'Item Mapping', desc: "Gets Part-Color-Code (A.K.A ElementID) of items", parent: '1.25'}}
				,	{id: '1.25.2', active: false, slug: 'get-item-number', name: 'Get item number', category: 'references', meta: {group: 'Item Mapping', desc: "Gets BL Catalog Item Number by Part-Color-Code (A.K.A ElementID)", parent: '1.25'}}

				,	{id: '2', active: false, slug: 'changelog', name: 'API Changelog'}
				,	{id: '3', active: false, slug: 'feedback-suggestions-requests', name: 'Feedback, Suggestions and Requests'}
			]
		};

		this.structured = this.returnStructuredReferences();
	}

	componentDidMount() {
		if(window.location.href.indexOf('?page') != -1) {
			const slug 			= window.location.href.split('?page=')[1];
			const pages 		= this.state.pages;
			const slugIndex = pages.findIndex(page => page.slug == slug);

			if(slugIndex != -1) {
				this.changePage(pages[slugIndex].id);
			}else{
				this.setState({altPage: slug});
			}
		}
	}

	render() {
		return (
			<main className="api-content-container">
				{this.renderSideNav()}
				<section className="api-main">
					{this.renderContent()}
					{this.renderFooter()}
				</section>
			</main>
		);
	}

	renderSideNav() {
		const pages = this.state.pages;

		const navItemsReferences = this.structured.map(group => {
			const children = group.children.map(groupChild => {
				const childChildren = !groupChild.children ? false : groupChild.children.map(item => 
					<li key={item.id} className={`api-reference-nav__child-children-item ${item.incomplete ? 'api-reference-nav__child-children-item--incomplete' : ''} ${pages[pages.findIndex(page => page.slug == item.slug)].active ? ' api-reference-nav__child-children-item--active' : ''}`}>
						<button onClick={!item.incomplete ? () => this.changePage(item.id) : null}>{item.name}</button>
						{item.incomplete && <i className={`fas fa-hammer api-reference-nav__incomplete`} title={"Not supported yet"}/>}
					</li>
				);

				return (
					<li key={groupChild.id} className={`api-reference-nav__child-item ${pages[pages.findIndex(page => page.slug == groupChild.slug)].active ? ' api-reference-nav__child-item--active' : ''}`}>
						<button onClick={() => this.changePage(groupChild.id)}>{groupChild.name}</button>
						{childChildren && 
							<ul className={`api-reference-nav__child-children`}>
								{childChildren}
							</ul>
						}
					</li>
				);
			});

			return(
				<div key={group.title} className={`api-reference-nav__group`}>
					<span className={`api-reference-nav__group-title`}>{group.title}</span>
					<ul className={`api-reference-nav__group-items`}>
						{children}
					</ul>
				</div>
			);
		});

		return (
			<aside className="api-side-nav">
				<header className="api-header">
					<div className="api-logo">
						<a href={blapp.url2.getMainPageUrl()}>
							<Logo base/>
						</a>
					</div>
					<span className="api-header__tag">API guide</span>
				</header>
				<ul className="api-nav">
					<li className={"api-nav__item api-nav__item--parent api-nav__item--main" + (pages[pages.findIndex(page => page.slug == 'started')].active ? ' api-nav__item--active' : '')} onClick={() => this.changePage(pages[pages.findIndex(page => page.slug == 'started')].id)}>Getting Started</li>
					<li className="api-nav__item--main api-nav__item--has-sub api-nav__item--utilities">
						<div className={"api-nav__item api-nav__item--parent" + (pages[pages.findIndex(page => page.slug == 'references')].active ? ' api-nav__item--active' : '')} onClick={() => this.changePage(pages[pages.findIndex(page => page.slug == 'references')].id)}>References</div>
						<ul className="api-nav__sub-nav">
							{navItemsReferences}
						</ul>
					</li>
					<li className={"api-nav__item api-nav__item--parent api-nav__item--main" + (pages[pages.findIndex(page => page.slug == 'changelog')].active ? ' api-nav__item--active' : '')} onClick={() => this.changePage(pages[pages.findIndex(page => page.slug == 'changelog')].id)}>Changelog</li>
					<li className={"api-nav__item api-nav__item--parent api-nav__item--main" + (pages[pages.findIndex(page => page.slug == 'feedback-suggestions-requests')].active ? ' api-nav__item--active' : '')} onClick={() => this.changePage(pages[pages.findIndex(page => page.slug == 'feedback-suggestions-requests')].id)}>Feedback, Suggestions and Requests</li>
				</ul>
			</aside>
		);
	}

	renderContent() {
		const activePage = this.state.pages.filter(page => page.active == true);
		const page = this.state.altPage ? this.state.altPage : activePage[0].slug;

		switch(page) {
			case 'started':
				return <GettingStarted/>;

			case 'general-notes':
				return <GeneralNotes/>;

			case 'auth':
				return <Auth/>;

			case 'error-handling':
				return <ErrorHandling/>;

			case 'resource-representations-order':
				return <ResourceRepOrder/>;

			case 'method-order':
				return <MethodOrder/>;

			case 'get-orders':
				return <GetOrders/>;

			case 'get-order':
				return <GetOrder/>;

			case 'get-order-items':
				return <GetOrderItems/>;

			case 'get-order-messages':
				return <GetOrderMessages/>;

			case 'get-order-feedback':
				return <GetOrderFeedback/>;

			case 'update-order':
				return <UpdateOrder/>;

			case 'update-order-status':
				return <UpdateOrderStatus/>;

			case 'update-payment-status':
				return <UpdatePaymentStatus/>;

			case 'send-drive-thru':
				return <SendDriveThru/>;

			case 'order-problem-reason':
				return <OrderProblemReason/>;

			case 'resource-representations-inventory':
				return <ResourceRepInventory/>;

			case 'method-inventory':
				return <MethodInventory/>;

			case 'get-inventories':
				return <GetInventories/>;

			case 'get-inventory':
				return <GetInventory/>;

			case 'create-inventory':
				return <CreateInventory/>;

			case 'create-inventories':
				return <CreateInventories/>;

			case 'update-inventory':
				return <UpdateInventory/>;

			case 'delete-inventory':
				return <DeleteInventory/>;

			case 'resource-representations-catalog':
				return <ResourceRepCatalog/>;

			case 'method-catalog':
				return <MethodCatalog/>;

			case 'get-item':
				return <GetItem/>;
			
			case 'get-item-image':
				return <GetItemImage/>;
			
			case 'get-supersets':
				return <GetSupersets/>;
			
			case 'get-subsets':
				return <GetSubsets/>;
			
			case 'get-price-guide':
				return <GetPriceGuide/>;
			
			case 'get-known-colors':
				return <GetKnownColors/>;

			case 'resource-representations-feedback':
				return <ResourceRepFeedback/>;

			case 'method-feedback':
				return <MethodFeedback/>;

			case 'get-feedback-list':
				return <GetFeedbackList/>;

			case 'get-feedback':
				return <GetFeedback/>;

			case 'post-feedback':
				return <PostFeedback/>;

			case 'reply-feedback':
				return <ReplyFeedback/>;

			case 'resource-representations-color':
				return <ResourceRepColor/>;

			case 'method-color':
				return <MethodColor/>;
				
			case 'get-color-list':
				return <GetColorList/>;

			case 'get-color':
				return <GetColor/>;

			case 'resource-representations-category':
				return <ResourceRepCategory/>;

			case 'method-category':
				return <MethodCategory/>;
				
			case 'get-category-list':
				return <GetCategoryList/>;

			case 'get-category':
				return <GetCategory/>;

			case 'resource-representations-push':
				return <ResourceRepPush/>;

			case 'method-push':
				return <MethodPush/>;

			case 'get-notifications':
				return <GetNotifications/>;

			case 'resource-representations-coupon':
				return <ResourceRepCoupon/>;

			case 'method-coupon':
				return <MethodCoupon/>;

			case 'get-coupons':
				return <GetCoupons/>;

			case 'get-coupon':
				return <GetCoupon/>;

			case 'create-coupon':
				return <CreateCoupon/>;

			case 'update-coupon':
				return <UpdateCoupon/>;

			case 'delete-coupon':
				return <DeleteCoupon/>;

			case 'resource-representations-setting':
				return <ResourceRepSetting/>;

			case 'method-setting':
				return <MethodSetting/>;

			case 'get-shipping-methods':
				return <GetShippingMethods/>;

			case 'get-shipping-method':
				return <GetShippingMethod/>;

			case 'resource-representations-member':
				return <ResourceRepMember/>;

			case 'method-member':
				return <MethodMember/>;

			case 'get-member-rating':
				return <GetMemberRating/>;

			case 'get-member-note':
				return <GetMemberNote/>;

			case 'create-member-note':
				return <CreateMemberNote/>;

			case 'update-member-note':
				return <UpdateMemberNote/>;

			case 'delete-member-note':
				return <DeleteMemberNote/>;

			case 'resource-representations-mapping':
				return <ResourceRepItemMapping/>;

			case 'method-mapping':
				return <MethodItemMapping/>;

			case 'get-elementid':
				return <GetElementID/>;

			case 'get-item-number':
				return <GetItemNumber/>;



			case 'references':
				return this.renderReferences();

			case 'changelog':
				return <Changelog/>;

			case 'feedback-suggestions-requests':
				return <FeedbackRequest/>;
		}
	}

	renderFooter() {
		const currentPageIndex = this.state.pages.findIndex(page => page.active == true);

		const prevPageIndex = currentPageIndex - 1;
		const nextPageIndex = currentPageIndex + 1;

		const prevPage = prevPageIndex >= 0 ? this.state.pages[prevPageIndex] : false;
		const nextPage = nextPageIndex <= this.state.pages.length - 1 ? this.state.pages[nextPageIndex] : false;

		return (
			<footer className="api-footer">
				{prevPage &&
					<button className="api-footer__btn api-footer__prev" onClick={() => this.changePage(prevPage.id)}>
						<p className="api-footer__title"><i className="fas fa-long-arrow-left l-margin-right--sm"/>Previous</p>
						<p className="api-footer__page-name">{prevPage.name}</p>
					</button>
				}
				{nextPage &&
					<button className="api-footer__btn api-footer__next" onClick={() => this.changePage(nextPage.id)}>
						<p className="api-footer__title">Next<i className="fas fa-long-arrow-right l-margin-left--sm"/></p>
						<p className="api-footer__page-name">{nextPage.name}</p>
					</button>
				}
			</footer>
		);
	}

	renderReferences() {
		const formattedReferences = this.structured.map(group => {
			const children = group.children.map(groupChild => {
				const childChildren = !groupChild.children ? false : groupChild.children.map(item => 
					<li key={item.id} className={`api-reference-page__child-children-item ${item.incomplete ? 'api-reference-page__child-children-item--incomplete' : ''}`}>
						<button onClick={!item.incomplete ? () => this.changePage(item.id) : null}>{item.name} : <span>{item.meta.desc}</span></button>
						{item.incomplete && <span className={`api-reference-page__flag--incomplete`}>Not supported yet</span>}
					</li>
				);


				return (
					<li className={`api-reference-page__child-item`}>
						<button onClick={() => this.changePage(groupChild.id)}>{groupChild.name}</button>
						{childChildren && 
							<ul className={`api-reference-page__child-children`}>
								{childChildren}
							</ul>
						}
					</li>
				);
			});

			return(
				<div className={`api-reference-page__group`}>
					<h2 className={`api-reference-page__group-title text--title`}>{group.title}</h2>
					<ul className={`api-reference-page__group-items bullet-list`}>
						{children}
					</ul>
				</div>
			);
		})

		return (
			<section>
				<h1 className="text--xxl-title l-margin-bottom--xl">API References</h1>
				{formattedReferences}
			</section>
		);
	}


	returnStructuredReferences() {
		const references = [...this.state.pages].filter(item => item.category == 'references');
		const structured = [];

		references.forEach(item => {
			const groupItemIndex = structured.findIndex(groupItem => groupItem.title == item.meta.group);

			if(item.meta.parent) {
				const group = structured.filter(group => item.meta.group == group.title)[0];

				if(group.children.length) {
					const parentItemIndex = group.children.findIndex(groupItem => groupItem.id == item.meta.parent);

					if(parentItemIndex != -1) {
						if(group.children[parentItemIndex].children) {
							group.children[parentItemIndex].children.push(item);
						}else{
							group.children[parentItemIndex].children = [item];
						}
					}
				}

			}else{
				if(groupItemIndex != -1) {
					structured[groupItemIndex].children.push(item);
				}else{
					structured.push({title: item.meta.group, children: [item]});
				}
			}
		});

		return structured;
	}

	changePage(pageId) {
		const pages = [...this.state.pages].map((page, key) => {
			page.id != pageId ? page.active = false : page.active = true;

			return page;
		});
		
		this.updateUrl();
		this.setState({altPage: '', pages: pages});
		window.scrollTo(0, 0);
	}

	updateUrl() {
		const activePage = this.state.pages.find(page => page.active == true);
		const url = window.location.href.indexOf('?page') != -1 ? window.location.href.split('?page')[0] : window.location.href;

		history.pushState('', `${activePage.name} page`, `${url}?page=${activePage.slug}`);
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem = ReactDOM.render(
							<Api blctx={{parent: null, idx:0}} />
						,	document.getElementById('bl-api')
						);
		blapp.refs.register("api", elem);
	}
);
 